// extracted by mini-css-extract-plugin
module.exports = {"contacts":"style_contacts__QWe51","mapWrapper":"style_mapWrapper__204aY","address":"style_address__LO2u4"};